import React from 'react';
import { JcCommonProps, JcUtils } from '../utils/JcUtils';
import { useJcFieldId } from '../utils/useJcFieldId';

export interface JcDateTimePickerProps extends JcCommonProps {
    readonly value: string; // Date in ISO format (YYYY-MM-DDThh:mm)
    readonly onChange: (value: string) => void;
    readonly min?: string; // Minimum date in ISO format
    readonly max?: string; // Maximum date in ISO format
    readonly disabled?: boolean;
}

export const JcDateTimePicker: React.FunctionComponent<JcDateTimePickerProps> = (props: JcDateTimePickerProps) => {
    const id = useJcFieldId(props.id);
    const commonProps = JcUtils.commonProps({ ...props, id }, ["jc-input", "jc-datetimepicker"]);

    return (
        <input
            {...commonProps}
            type="datetime-local"
            value={props.value}
            min={props.min}
            max={props.max}
            disabled={props.disabled}
            onChange={e => props.onChange(e.target.value)}
        />
    );
};
